import type { ProcessDto } from '@nsb/core';
import { JobTree } from '../tree/JobTree.tsx';
import { useProcessModel } from './useProcess.ts';

/**
 * A project's process drawn (process-flow spec, "Admin configuration"; design study 12): the master's drawing, the job's
 * own way of growing on it (JobTree), on a wide screen and, recomposed as rows, on a phone. Setting it up (the project's
 * Settings, Process) or running it (the Process page; Jason, 2026-10-07: "Yes, build it this way").
 */
export function ProcessEditor({ projectId, dto, setup }: { projectId: string; dto: ProcessDto; setup: boolean }) {
  const model = useProcessModel(dto);
  if (!model) return null;
  return <JobTree projectId={projectId} model={model} setup={setup} />;
}
